const init = {
    loading: false,
    announcements: null,
    requestBody: null,
    error: undefined,
    isSaved: false
  };
  
  export const announcements = (state = init, action) => {
    switch (action.type) {
      case "FETCH_ANNOUNCEMENTS_START":
        return { ...state, loading: true,isSaved:false };
      case "FETCH_ANNOUNCEMENTS_SUCCESS":
        return { ...state, loading: false, announcements: action.payload,isSaved:false };
      case "FETCH_ANNOUNCEMENTS_FAILURE":
        return { ...state, loading: false, error: action.payload,isSaved:false };
      case "SAVE_ANNOUNCEMENTS_START":
        return { ...state, loading: true, isSaved: false };
      case "SAVE_ANNOUNCEMENTS_SUCCESS":
        return { ...state, loading: false, isSaved: true,error:undefined };
      case "SAVE_ANNOUNCEMENTS_FAILURE":
        return { ...state, loading: false, error: action.payload,isSaved: false };
      default:
        return state;
    }
  };
  